export function LoadingScreen() {
  const logoSrc = `${import.meta.env.BASE_URL}pwa-192x192.png`;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white">
      <img
        src={logoSrc}
        alt="mdsync"
        className="h-36 w-36 animate-in fade-in duration-500 sm:h-44 sm:w-44"
      />
    </div>
  );
}
